import apiRequest from './apiRequest';

export default async function deleteMedia(mediaID: string) {
  return await apiRequest('mogen-orchestration', `/media/${mediaID}`, {
    method: 'DELETE',
  });
}
